/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/app/store';
import Dashboard from '../Dashboard';
import Library from '../Library/Library';

const Home: React.FC = () => {
  const { enterpriseProfile } = useSelector(
    (state: RootState) => state.dashboard
  );

  if (enterpriseProfile.isFetchingProfile === true) {
    return <></>;
  }

  // For MTR Enterprise users the library page will be the default page upon sign in
  return enterpriseProfile.isEnterpriseProfile ? <Library /> : <Dashboard />;
};

export default Home;
